import { StorageRootDto } from "../StorageRootDto";
import { Network } from "../../DiscoveryEngine.TS/Core/Network";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";

export class RollupDto extends StorageRootDto {

	public UserGuid: string;
	public EntityType: string;
	public EntityGuid: string;
	public Network: Network;
	public InputGuids: List<string>;

	constructor() {
		super();

		this.UserGuid = "";
		this.EntityType = "";
		this.EntityGuid = "";
		this.Network = null;
		this.InputGuids = new List<string>();
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasEntityType(): boolean {
		return !!this.EntityType;
	}

	public get HasEntityGuid(): boolean {
		return !!this.EntityGuid;
	}

	public get HasNetwork(): boolean {
		return !!this.Network;
	}

	public get HasInputGuids(): boolean {
		return (!!this.InputGuids && this.InputGuids.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.rollup = {};
		obj = obj.rollup;

		super.Write(obj, context);

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.HasEntityType)
			obj.entity_type = this.EntityType;

		if (this.HasEntityGuid)
			obj.entity_guid = this.EntityGuid;

		if (this.HasNetwork)
			this.Network.Write(obj, context);

		if (this.HasInputGuids) {
			obj.input_guids = [];
			ObjSerUtils.WriteStringCollection(obj.input_guids, this.InputGuids, "value", context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.rollup)
			throw new Error();
		obj = obj.rollup;

		super.Read(obj, context);

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.entity_type !== undefined)
			this.EntityType = obj.entity_type;

		if (obj.entity_guid !== undefined)
			this.EntityGuid = obj.entity_guid;

		if (obj.network !== undefined) {
			this.Network = new Network();
			this.Network.Read(obj, context);
		}

		if (obj.input_guids !== undefined) {
			this.InputGuids.Clear();
			ObjSerUtils.ReadStringCollection(obj.input_guids, this.InputGuids, "value", context);
		}
	}

}